<template>
<div class="cx-row--line -hidden-md" @click="dismissWatcher">
  <ul class="cx-list m-header__mobilelist">
    <li class="cx-list__item m-header__mobileitem">
      <font-size-selector mobile />
    </li>
    <li class="cx-list__item m-header__mobileitem">
      <language-selector mobile />
    </li>
    <li class="cx-list__item m-header__mobileitem">
      <main-header-search-btn mobile />
    </li> 
    <li class="cx-list__item">
      <div class="cx-offcanvas">
        <a role="button" href="#" class="cx-link--stack cx-offcanvas__trigger js-trigger" @click.prevent="activeMenu" :aria-label="$t('common.menu')">
          <span class="cx-link__icon">
            <i class="fal fa-bars"></i>
          </span>
          <span class="cx-link__text"
          >{{$t('common.menu')}}</span>
        </a>

        <div ref="mobileMenuContainer" :class="showMenu ? '-shown': ''"
          class="cx-offcanvas__content cx-wrap m-header__mobilemenu">
          <div class="m-header__mobilemenu-list">
            <div class="cx-div">
              <div class="cx-row--line cx-t20">
                <div class="cx-col">
                  <div class="theme-logo m-header__mobilemenu-logo">
                    <router-link-localed 
                      :to="{name: `Home_${$i18n.locale}`}"
                      :aria-label="$t('home.home')"
                    ><cx-img
                        tag="div"
                        :imgSrc="'/static/logo/mgto-logo.svg'"
                        class="theme-logo__img m-header__mobilemenu-logoimg router-link"
                        svg
                      ></cx-img>
                    </router-link-localed >
                  </div>
                </div>
                <div class="cx-col">
                  <a id="dismiss-menu-close-button" role="button" href="#" class="js-close" :aria-label="$t('action.close')" @click.prevent="dismissMenu">
                    <i class="fal fa-times"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="cx-div cx-t02 -fade2">
              <main-header-weather-status  @click.native="dismissMenu"/>
            </div>
            <div class="cx-div">
              <ul class="cx-list--vertical m-header__mobilemenu-main">
                <li class="cx-list__item">
                  <router-link-localed
                    to='/'>
                    <span>{{ $t( 'home.home' ) }}</span>
                  </router-link-localed>
                </li>
                <li class="cx-list__item">
                  <a class="cx-link"
                    href='https://tripplanner.macaotourism.gov.mo/'>
                    <span>{{ $t('trip.smartTripPlanner') }}</span>
                  </a>
                </li>
                <li class="cx-list__item">
                  <cx-dropdown trigger="click" keepDropdownAfterClick keepDropdownAfterBlur>
                    <span class="cx-link js-dropdown" slot-scope="{ active }">
                      <span>{{$t('header.planYourTrip')}}</span>
                      <span class="cx-link__icon">
                        <i :class="`fas fa-angle-${active ? 'up' : 'down'}`"></i>
                      </span>
                    </span>
                    <template slot="content" :menu="travelEssentialMenu">
                      <div class="m-header__dropdown-content">
                        <div class="cx-div" v-if="hasTripLink">           
                          <router-link-localed
                            tag="div"
                            to="/macao-full-of-fun"
                            class="cx-t01 -border-bottom m-subtitle m-header__dropdown-title router-link"
                          >{{$t('trip.trips')}}</router-link-localed>
                          <ul class="cx-list--vertical cx-t01 m-header__dropdown-subsection -fade">
                            <template v-for="i in 5">
                              <li class="cx-list__item"
                                v-if="$te(`trip.menuItem${i}Link`) && $t(`trip.menuItem${i}Link`)"
                                :key="$t(`trip.menuItem${i}Label`)"
                              >
                                <component 
                                  :is="''"
                                  class="cx-link"
                                  v-bind="linkProps($t(`trip.menuItem${i}Link`))"
                                >{{$t(`trip.menuItem${i}Label`)}}</component>
                              </li>
                            </template>
                          </ul>
                        </div>
                        <div class="cx-div" v-for="group in travelEssentialMenu" :key="group.id">
                          <router-link-localed 
                            tag="div"
                            :to="`/travelessential#${group.id}`" 
                            class="cx-t01 -border-bottom m-subtitle m-header__dropdown-title router-link">
                            {{group.name}}
                          </router-link-localed>
                          <ul class="cx-list--vertical cx-t01 m-header__dropdown-subsection -fade">
                            <li class="cx-list__item"
                              v-for="item in group.items"  
                              :key="item.slug">
                              <component
                                :is="''"
                                v-bind="linkProps(item.link 
                                  ? item.link 
                                  : `/article/${item.category}/${item.slug}`
                                )"
                                class="cx-link"
                              >{{item.name}}</component>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </template>
                  </cx-dropdown>
                </li>
                <li class="cx-list__item">
                  <cx-dropdown trigger="click" keepDropdownAfterClick keepDropdownAfterBlur>
                    <span class="cx-link cx-dropdown__trigger" slot-scope="{ active }">
                      <span>{{$t('header.experience')}}</span>
                      <span class="cx-link__icon">
                        <i :class="`fas fa-angle-${active ? 'up' : 'down'}`"></i>
                      </span>
                    </span>
                    <template slot="content" :menu="experienceMenu">
                      <div class="m-header__dropdown-content">
                        <div class="cx-div" v-for="item in experienceMenu" :key="item.category">
                          <router-link-localed 
                            tag="div"
                            :to="`/${item.category}`"
                            class="cx-t01 -border-bottom m-subtitle m-header__dropdown-title router-link"
                          >{{item.name}}</router-link-localed>
                          <ul class="cx-list--vertical cx-t01 m-header__dropdown-subsection -fade">
                            <li class="cx-list__item"
                              v-for="g in item.groups"  
                              :key="g.group">
                              <router-link-localed 
                                class="cx-link" 
                                :to="`/${item.category}/${g.group}`"
                              >{{g.name}}</router-link-localed>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </template>
                  </cx-dropdown>
                </li>
                <li class="cx-list__item">
                  <router-link-localed to="/dining" class="cx-link"
                  >{{$t('header.diningOut')}}</router-link-localed>
                </li>
                <li class="cx-list__item">
                  <router-link-localed to="/whatson" class="cx-link"
                  >{{$t('enf.whatsOn')}}</router-link-localed>
                </li>
                <!-- <li class="cx-list__item">
                  <router-link-localed to="/events" class="cx-link"
                  >{{$t('enf.enf')}}</router-link-localed>
                </li> -->
                <li class="cx-list__item">
                  <router-link-localed to="/accommodation" class="cx-link"
                  >{{$t('header.accommodation')}}</router-link-localed>
                </li>
              </ul>
            </div>
            <div class="cx-div">
              <ul class="cx-list--vertical -fade2">
                <li class="cx-list__item">
                  <a class="cx-link"
                    rel="noopener noreferrer" target="_blank"
                    :href="`https://www.dst.gov.mo/${['zh-hant','zh-hans','pt','en'].includes($i18n.locale) ? $i18n.locale : 'en'}/home.html`">
                    {{$t('header.industryNet')}}
                  </a>
                </li>
                <li v-if="$t('accessibility.barrierFreeTravelGuide')" class="cx-list__item">
                  <router-link-localed to="/barrier-free-access-guide" class="cx-link"
                  >{{$t('accessibility.barrierFreeTravelGuide')}}</router-link-localed>
                </li>
                <li class="cx-list__item">
                  <router-link-localed to="/video-playlists" class="cx-link"
                  >{{$t('videoGallery.videoGallery')}}</router-link-localed>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
import { mapState } from 'vuex';
import FontSizeSelector from '@/components/FontSizeSelector';
import LanguageSelector from '@/components/LanguageSelector';
import MainHeaderSearchBtn from '@/components/MainHeaderSearchBtn';
import MainHeaderWeatherStatus from '@/components/MainHeaderWeatherStatus';

export default {
  name: 'main-header-mobile',
  uit() {
    return [
      ['action', ['close']],
      ['videoGallery', [
        'videoGallery',
      ]],
      ['enf', [
        'enf',
        'whatsOn',
      ]],
      ['trip',['smartTripPlanner']],
      ['header', [
        'industryNet',
        'planYourTrip',
        'experience',
        'diningOut',
        'accommodation'
      ]],
      ['home', ['home']],
      ['common', [
        'menu'
      ]],
      ['trip', [
        'trips',
        'suggestedTour',
        'menuItem1Label',
        'menuItem1Link',
        'menuItem2Label',
        'menuItem2Link',
        'menuItem3Label',
        'menuItem3Link',
        'menuItem4Label',
        'menuItem4Link',
        'menuItem5Label',
        'menuItem5Link',
        // 'tripPlanner',
      ]],
      // ['followTheStar', [
      //   'followTheStar',
      // ]],
      ['accessibility', [
        'barrierFreeTravelGuide',
      ]],
    ]
  },
  data() {
    return {
      // showMenu: false,
    };
  },
  props: {
    experienceMenu: {
      type: Array,
      default: () => [],
    },
    travelEssentialMenu: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      showMenu: state => state.ui.mobileHeader,
    })
  },
  components: {
    FontSizeSelector,
    LanguageSelector,
    MainHeaderSearchBtn,
    MainHeaderWeatherStatus,
  },
  mounted() {
    const mobileMenuContainer = this.$refs.mobileMenuContainer;
    const createFocusTrap = window.focusTrap && window.focusTrap.createFocusTrap;
    if (createFocusTrap) {
      if (mobileMenuContainer) {
        this.mobileMenuTrap = createFocusTrap(mobileMenuContainer, {
          allowOutsideClick: true,
          initialFocus: '#dismiss-menu-close-button',
        });
      }
    }
  },
  methods: {
    hasTripLink: function() {
      return Array.apply(null, Array(5)).some((_, idx) => {
        return this.$te(`trip.menuItem${idx + 1}Link`) 
          && this.$t(`trip.menuItem${idx + 1}Link`)
      })
    },
    activeMenu() {
      this.$store.dispatch('ui/ACTIVE_MOBILE_HEADER');
      if (this.mobileMenuTrap) {
        this.mobileMenuTrap.activate();
      }
    },
    dismissMenu() {
      this.$store.dispatch('ui/DISMISS_MOBILE_HEADER');
      if (this.mobileMenuTrap) {
        this.mobileMenuTrap.deactivate();
      }
    },
    dismissWatcher(e) {
      let target = event.target || {};
      if ((target.tagName === 'A' && !target.classList.contains('js-trigger'))
        || target.classList.contains('router-link')
      ) { this.dismissMenu() }
    }
  },
}
</script>

<style lang="scss">

</style>
